import { Nullable } from "@/api/ApiClient";
import { WithReferenceCode } from "./ReferenceCodeType";

export type ExpenseFormData = WithReferenceCode<Nullable<{
    id: string | undefined,
    sequence: string,
    document_key: string,
    fecha: string,
    nombre: string,
    identificacion: string,
    subtotal: number,
    impuestos: number,
    descuento: number,
    monto: number,
    detalle: string,
    exchange_rate: number,
    excluir_reporte: boolean,
    expenseCategoryId: string,
    expenseCategory: any,
    currencyId: string,
    currency: any,
    expenseNotes: any[],
    user: string,
}>>;

export const ExpenseRelatedAttributes: Array<keyof ExpenseFormData> = ["expenseCategory", "currency", "expenseNotes"];